import React from 'react';
import { ISvgProps } from '../svg.types';

export const CrossMediumLayer = (props: ISvgProps) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <filter
        x="-1.1%"
        y="-35.8%"
        width="102.1%"
        height="178.3%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={7.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0967787591 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path id="b" d="M0 0h2190v60H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1629 -17)">
        <use fill="#000" filter="url(#a)" xlinkHref="#b" />
        <use fill="#FFF" xlinkHref="#b" />
      </g>
      <path
        d="M12.98 14.536l-8.91 8.91c-.468.468-1.196.5-1.626.07-.43-.43-.398-1.158.07-1.627l8.91-8.91-9.05-9.05c-.47-.469-.501-1.197-.071-1.626.43-.43 1.157-.398 1.626.07l9.05 9.051 9.052-9.05c.468-.47 1.197-.501 1.626-.071.43.43.398 1.157-.07 1.626l-9.051 9.05 8.91 8.91c.468.47.5 1.197.07 1.627-.43.43-1.158.398-1.627-.07l-8.91-8.91z"
        fill="#545454"
      />
    </g>
  </svg>
);
